import React from 'react';
import HelpItemContainer from '../Help/HelpItemContainer';
import {
  EDIT_FIELD_BOUNDARIES_HELP_ARTICLE,
  SPLIT_FIELD_HELP_ARTICLE,
  MERGE_FIELDS_HELP_ARTICLE,
} from '../../reducers/HelpReducer';

export const PolygonDrawingHelpIcon = ({ drawingMode }) => {
  switch (drawingMode) {
    case 'EDIT_FIELD_BOUNDARIES':
      return <HelpItemContainer type="icon" articleId={EDIT_FIELD_BOUNDARIES_HELP_ARTICLE} />;
    case 'SPLIT_FIELD':
    case 'SPLIT_FIELD_POLYGONS':
      return <HelpItemContainer type="icon" articleId={SPLIT_FIELD_HELP_ARTICLE} />;
    case 'EDIT_MERGED_FIELD':
      return <HelpItemContainer type="icon" articleId={MERGE_FIELDS_HELP_ARTICLE} />;
    default:
      return null;
  }
};
